module.exports = __webpack_public_path__ + "img/DSC04607-2.504e250e.jpg";